import React from 'react';
import Avatar from '@mui/material/Avatar';

export const UserAvatar = ({ text, sx }) => {
  // Split the text into an array of words
  const words = text.split(' ');

  let initials;

  if (words.length === 1) {
    // If only one word, take the first letter
    initials = words[0].charAt(0).toUpperCase();
  } else {
    // If two words, take the first letter of each word
    initials = `${words[0].charAt(0).toUpperCase()}${words[1].charAt(0).toUpperCase()}`;
  }

  return (
    <Avatar sx={{ bgcolor: '#9C27B0', width: 30, height: 30, fontSize: '14px', ...sx }}>
      {initials}
    </Avatar>
  );
};

export default UserAvatar;
